export type UpdateComponentAttributeTicketStatusesResponse = {};
